module.exports = __webpack_public_path__ + "img/upenn-logo.1702ffda.png";